import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, takeUntil, withLatestFrom } from 'rxjs';
import * as fromUploader from '@app/client/uploader/store/reducers';
import { Store } from '@ngrx/store';
import { Promotion } from '@app/shared/models/promotion';
import { PrepareActions } from '@app/client/uploader/store/actions';


@Injectable({
    providedIn: 'root'
})
export class ResolveExternalPromotionService {

    constructor(
        private readonly store$: Store<fromUploader.State>,
    ) { }

    resolve(): Observable<{ selectedPromotion: Promotion, promotions: Promotion[] }> {
        const resolvedPromotion$ = new ReplaySubject<{ selectedPromotion: Promotion, promotions: Promotion[] }>();
        this.store$.pipe(
            withLatestFrom(
                this.store$.select(fromUploader.getExternalPromotionSelected),
                this.store$.select(fromUploader.getExternalPromotions),
                this.store$.select(fromUploader.getExternalPromotionsLoading),
                this.store$.select(fromUploader.getExternalPromotionsLoaded),
                this.store$.select(fromUploader.getExternalPromotionsError),
            ),
            takeUntil(resolvedPromotion$)
        ).subscribe(([store, selectedPromotion, promotions, promotionLoading, promotionLoaded, promotionError]) => {
            if (promotionLoaded || promotionError) {
                resolvedPromotion$.next({ selectedPromotion, promotions });
            } else if (!promotionLoading && !promotionLoaded) {
                this.store$.dispatch(PrepareActions.loadExternalPromotions());
            }
        });

        return resolvedPromotion$.asObservable();
    }
}